import { api, ReactQueryOptions, RouterInputs } from '@api';
import { useSession } from '@shared/hooks/useSession';
type optionsType = ReactQueryOptions['BlockManager']['isBlocked'];
type inputType = RouterInputs['BlockManager']['isBlocked'];
export const useGetIsBlocked = (input: inputType, options?: optionsType) => {
  const {
    status
  } = useSession();
  const {
    data
  } = api.BlockManager.isBlocked.useQuery(input, {
    ...options,
    queryKey: ['BlockManager.isBlocked', input],
    refetchOnReconnect: true,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    enabled: status === 'authenticated' && options?.enabled
  });
  return {
    isBlocked: data?.status === 'success' ? data.isBlocked : false
  };
};